import CompositionGrid from './CompositionGrid';

export default CompositionGrid;
